import React from 'react';
export const ProductDetails = () => {
  return <div className="w-full bg-gray-100 py-12" data-id="element-92">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-93">
        <h2 className="text-2xl font-bold text-green-900 text-center mb-2" data-id="element-94">
          The Daily Foundation Chew™: Your Dog's Ancestral Nutrition Restored
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-95">
          One delicious chew delivers:
        </p>
        <div className="flex flex-col md:flex-row gap-8 items-center mb-12" data-id="element-96">
          <div className="md:w-1/2" data-id="element-97">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o75BgGDqzFjrZFgshC8kaD/topview_image_68d9dcb18c9d4daba553d7fe95210fa7.png" alt="The Daily Foundation Chew product" className="rounded-lg shadow-md w-full" data-id="element-98" />
          </div>
          <div className="md:w-1/2" data-id="element-99">
            <ul className="space-y-4" data-id="element-100">
              <li className="flex items-start" data-id="element-101">
                <span className="text-amber-600 font-bold text-lg mr-3" data-id="element-102">•</span>
                <span data-id="element-103">
                  <span className="font-bold" data-id="element-104">750mg</span> Ancestral Core Blend
                  (grass-fed liver, heart, kidney)
                </span>
              </li>
              <li className="flex items-start" data-id="element-105">
                <span className="text-amber-600 font-bold text-lg mr-3" data-id="element-106">•</span>
                <span data-id="element-107">
                  <span className="font-bold" data-id="element-108">500mg</span> Green-Lipped Mussel
                  for inflammation support
                </span>
              </li>
              <li className="flex items-start" data-id="element-109">
                <span className="text-amber-600 font-bold text-lg mr-3" data-id="element-110">•</span>
                <span data-id="element-111">
                  <span className="font-bold" data-id="element-112">100mg</span> CurcuVET® (29x more
                  bioavailable than regular turmeric)
                </span>
              </li>
              <li className="flex items-start" data-id="element-113">
                <span className="text-amber-600 font-bold text-lg mr-3" data-id="element-114">•</span>
                <span data-id="element-115">
                  <span className="font-bold" data-id="element-116">1 Billion CFU</span> Soil-Based
                  Probiotics that actually survive stomach acid
                </span>
              </li>
              <li className="flex items-start" data-id="element-117">
                <span className="text-amber-600 font-bold text-lg mr-3" data-id="element-118">•</span>
                <span data-id="element-119">
                  <span className="font-bold" data-id="element-120">50mg</span> Organic Spirulina for
                  internal deodorizing
                </span>
              </li>
            </ul>
            <div className="mt-8 p-4 bg-green-50 rounded-lg" data-id="element-121">
              <h3 className="font-bold text-green-900 mb-2" data-id="element-122">Why It Works:</h3>
              <p className="text-gray-700" data-id="element-123">
                This isn't another Band-Aid solution. It's a complete
                restoration of the nutrients your dog's body was designed to
                thrive on – the same nutrients their wild ancestors got
                naturally but modern kibble has eliminated.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};